<template>
  <div class="flex flex-col min-h-screen" :class="{ 'overflow-hidden': $route.name !== 'ResumeGenerator' }">
    <navbar :lightNav="'justify-start'" :container="'container'" />
      <router-view :key="$route.params.slug" />
    <footers class="mt-auto" />
  </div>
  <ErrorBoundary v-if="userLoggedIn">
    <CometChat />
  </ErrorBoundary>
  <FloatingButton />
</template>

<script>
import FloatingButton from "@/components/utility/WhatsappButton.vue";
import navbar from '@/components/navbar/Navbar.vue';
import footers from '@/components/footer/footer.vue';
import CometChat from '@/components/message/CometChat.vue'
import { globalState } from '@/events/useGlobalState';
import ErrorBoundary from '@/components/utility/ErrorBoundary.vue';
import loadMatomo from '@/services/util/matomo.js';
import loadLeadfeeder from '@/services/util/leadfeeder.js'

export default {
  components: {
    navbar,
    footers,
    ErrorBoundary,
    CometChat,
    FloatingButton,
  },
  data() {
    return {
      userLoggedIn: false,
    };
  },
  async mounted () {
    window.addEventListener('storage', this.handleStorageChange);

    const userData = JSON.parse(localStorage.getItem('userInfo')) || {};
    if (userData.uuid) {
      this.userLoggedIn = true;
    }

    loadMatomo();
    loadLeadfeeder();
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    handleStorageChange(event) {
      console.log(event, event)
      if (event.key === 'avatar') {
        globalState.avatar = event.newValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
